import React from "react";
import { Link } from "react-router-dom";
import ThemeToggle from "../components/ui/themeToggle";

export default function ResetPasswordNotice() {
  return (
    <main className="min-h-screen bg-slate-50 px-4 py-12 text-slate-900 dark:bg-neutral-950 dark:text-white">
      <section className="relative mx-auto max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm dark:border-neutral-800 dark:bg-neutral-900">
        <div className="mb-8 flex justify-end"><ThemeToggle /></div>
        <h1 className="text-2xl font-semibold">Redefinir senha</h1>
        <p className="mt-4 text-sm leading-6 text-slate-600 dark:text-neutral-300">
          A senha agora é redefinida na página segura do Keycloak. Use o link recebido por e-mail. Os links antigos desta aplicação não são mais válidos.
        </p>
        <Link className="mt-6 block rounded-lg bg-blue-700 px-4 py-3 text-center font-medium text-white hover:bg-blue-800" to="/recuperar-senha">
          Solicitar um novo link
        </Link>
      </section>
    </main>
  );
}
